module.exports = __webpack_public_path__ + "src/img/voiceNotice.c137429a.svg";